import React from 'react'
import PropTypes from 'prop-types'
import Slider from "react-slick"
// Import css files
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

export default function Carousel({ items, settings }) {
  const dSettings = {
    dots: true,
    arrows: false,
    speed: 3500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    cssEase: "linear",
    pauseOnHover: false,
    swipeToSlide: true,
    autoplaySpeed: 1000,
    draggable: true,
  }
  if (!settings) {
    settings = dSettings
  } else {
    settings = {
      ...dSettings,
      ...settings
    }
  }
  return (
    <>
      <Slider {...settings}>{items}</Slider>
    </>
  )
}

Carousel.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  settings: PropTypes.object
}